import React from "react";
import { Flame, MapPin } from "lucide-react";

export default function CowboySushiAd() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          Cowboy Sushi Ad · 1080×1080
        </p>

        <div
          data-testid="cowboy-sushi-ad"
          className="relative w-[540px] h-[540px] overflow-hidden bg-black"
        >
          {/* Hero food image */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: "url(/menu/bbq_sushi.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "saturate(1.18) contrast(1.05)",
            }}
          />
          {/* Top/bottom dark gradients */}
          <div
            className="absolute inset-x-0 top-0 h-[55%]"
            style={{
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.45) 60%, transparent 100%)",
            }}
          />
          <div
            className="absolute inset-x-0 bottom-0 h-[45%]"
            style={{
              background:
                "linear-gradient(0deg, rgba(0,0,0,0.96) 0%, rgba(0,0,0,0.6) 60%, transparent 100%)",
            }}
          />
          {/* Ember glow */}
          <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at 50% 50%, transparent 35%, rgba(255,59,48,0.12) 90%)",
            }}
          />
          {/* Grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-25 mix-blend-screen pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          {/* Brand top-left */}
          <div className="absolute top-5 left-5 flex items-center gap-2 z-10">
            <Flame
              className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.8)]"
              style={{ width: 18, height: 18 }}
            />
            <span
              className="font-['Anton'] uppercase text-white tracking-[0.3em]"
              style={{ fontSize: 13 }}
            >
              Smokey <span className="text-[#FF3B30]">AF</span>
            </span>
          </div>

          {/* NEW + City of Fremont stamp top-right */}
          <div
            className="absolute top-5 right-5 bg-[#FF3B30] text-white font-['Anton'] uppercase tracking-wider px-3 py-1.5 rotate-3 shadow-[0_8px_24px_rgba(255,59,48,0.5)]"
            style={{ fontSize: 13 }}
          >
            New · Fremont
          </div>

          {/* Eyebrow */}
          <div className="absolute top-[60px] left-6 right-6 z-10 text-center">
            <div className="inline-flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5 text-[#FF8C00]" />
              <span
                className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.45em]"
                style={{ fontSize: 10 }}
              >
                Nebraska Meets Tokyo
              </span>
            </div>
          </div>

          {/* Big headline */}
          <div className="absolute top-[100px] left-6 right-6 z-10 text-center">
            <h1
              className="font-['Anton'] uppercase leading-[0.82] drop-shadow-[0_8px_25px_rgba(0,0,0,0.95)]"
              style={{ fontSize: 86, letterSpacing: "-0.025em" }}
            >
              <span className="text-white">Cowboy</span>
              <br />
              <span style={{ color: "#FF3B30" }}>Sushi.</span>
            </h1>
            <p
              className="mt-3 font-['Outfit'] italic text-zinc-200"
              style={{ fontSize: 14 }}
            >
              Yes, you read that right.
            </p>
          </div>

          {/* Bottom — description + price + CTA */}
          <div className="absolute inset-x-0 bottom-0 z-10 px-6 pb-6">
            <p
              className="text-center font-['Outfit'] text-zinc-200 leading-snug max-w-[440px] mx-auto"
              style={{ fontSize: 14 }}
            >
              Smoked pulled pork, purple peppers, sushi rice, nori.
              <br />
              Japanese BBQ dipping sauce on the side.
            </p>

            <div className="mt-4 flex items-center justify-between">
              <div
                className="bg-[#FF3B30] text-white font-['Anton'] tracking-wider px-4 py-2 rotate-3 shadow-[0_8px_24px_rgba(255,59,48,0.6)]"
                style={{ fontSize: 38 }}
              >
                $8
              </div>
              <span
                className="font-['Anton'] tracking-widest uppercase bg-white text-black px-4 py-2.5"
                style={{ fontSize: 13 }}
              >
                Order Online
              </span>
            </div>
            <div
              className="mt-2 text-center font-['Outfit'] uppercase text-zinc-400 tracking-[0.3em]"
              style={{ fontSize: 9 }}
            >
              Inside Southern Style Bar · 648 N Broad St · smokey-af-bbq.emergent.host
            </div>
          </div>
        </div>

        <a
          href="/ads/cowboy_sushi_ad.png"
          download
          data-testid="cowboy-sushi-dl"
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
